import ComponentBase from "@components/ComponentBase";
import { ComponentElem } from "@components/interfaces";
import { Common } from "../../common/CommonTypes";
import gsap from "gsap";
import Utility from "@/src/scripts/ts/sframe/Utility";

const MY_HTML = `
<div component="activity-promote">
  <div class="wrapper">
    <div class="alert"></div>
    <div class="text">限時推出精選活動，快來領取折扣碼享百元現金折抵！元現金折抵！</div>
    <a class="btn">前往活動</a>
    <div class="polyfill"></div>
    <div class="btn-close"></div>
  </div>
</div>
`;

const COOKIE_NAME = "ez-closed-activity-promote-id";

export default class ActivityPromote extends ComponentBase
{
  static generate(data: Common.ActivityPromoteData)
  {
    try {
      if(Utility.urlParams.reset_activity === "1") localStorage.removeItem(COOKIE_NAME);
      let closedId = localStorage.getItem(COOKIE_NAME);
      if (data.id === closedId) return;
    } catch (e) { }

    let $elem = $(MY_HTML);

    $elem.find(".text").text(data.text);
    $elem.find(".btn").text(data.button_text).attr("href", data.url).attr("target", data.target ? data.target : "_self");
    $elem[0].dataset.id = data.id;

    new ActivityPromote($elem[0]);

    gsap.from($elem, { duration: .2, height: 0 });
    $(".section-wrapper").prepend($elem);
  }

  constructor(elem: ComponentElem)
  {
    super(elem);

    this.$root.find(".btn-close").on("click", (event: JQuery.ClickEvent) =>
    {
      event.preventDefault();
      this.hide();

      try {
        localStorage.setItem(COOKIE_NAME, this.$root[0].dataset.id);
      }
      catch (e) { };
    });
  }

  hide()
  {
    let tl = gsap.timeline();
    tl.to(this.$root, { duration: .2, height: 0 });
    tl.add(() =>
    {
      this.$root.detach();
    });
  }
}